import React from 'react';
import SvgIcon from './SvgIcon';
import { SvgIconProps } from './types';

// Filled "keep_off" (push pin with a slash) — the counterpart to PushPinIcon,
// shown on a pinned feed to mean "unpin". Material Symbols filled variant, so
// it uses the 960 grid rather than the 24px one.
const KeepOffIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} height="24" width="24" viewBox="0 -960 960 960">
        <path d="M680-840v80h-40v327L313-760l-33-33v-47h400ZM480-40l-40-40v-240H240v-80l80-80v-46L56-792l56-56 736 736-58 56-264-264h-6v240l-40 40Z" />
    </SvgIcon>
);

export default KeepOffIcon;
